import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {iconX, iconCarretLeft} from "../common/Icon";
import {Button, AjaxSpinner, PopupWindow, handleEvent} from "@utahdts/dts-react-common";
import MainMenuItem from "./main-menu-item";
import _ from 'lodash';
import webservice, {ajaxStatus, WEBSERVICE_AJAX_ID} from "../common/Webservice";
import {COBI_HIERARCHY, mapMenu, formatCobiYear, MEDIA_SIZES, dispatchUpdateData, isAllowed} from "../misc/Shared";
import {Link} from 'react-router-dom';
import Media from "react-media";
import Version from "../pages/Version";

const propTypes = {
	admin: PropTypes.bool.isRequired,
	// The current cobiId that the user is viewing
	currentCobiId: PropTypes.number.isRequired,

	currentTab: PropTypes.string,

	// The current year that the user is viewing
	currentYear: PropTypes.number.isRequired,

	draft: PropTypes.bool,

	// The list of available years
	fiscalYears: PropTypes.array.isRequired,

	// The browser history object (provided by react router)
	history: PropTypes.object.isRequired,

	// an object that describes the current menu structure with cobiId as the key
	menuMap: PropTypes.object.isRequired,

	// The menu object that describes the current menu structure
	menuObj: PropTypes.object.isRequired,

	// A function that is called when the user wishes to close the menu
	menuClose: PropTypes.func.isRequired,
};

// Props connected to the store
const mapStateToProps = (state) => {
	return {
		admin: state.app.admin,
		currentCobiId: state.app.currentCobiId,
		currentYear: state.app.currentYear,
		currentTab: state.app.currentTab,
		draft: state.app.draft,
		fiscalYears: state.app.fiscalYears,
		menuMap: state.menu.menuMap,
		menuObj: state.menu.menuObj,
	};
};

class MainMenu extends React.Component {
	constructor(props) {
		super(props);

		/*
			{
				text: string,
				selectedMenuItem: object,
				menuItems: array(objects)
			}
		*/
		this.menu = {
			[COBI_HIERARCHY.SUBCOMMITTEE]: {
				text: 'Subcommittees',
				selectedMenuItem: undefined,
				menuItems: undefined,
			},
			[COBI_HIERARCHY.AGENCY]: {
				text: 'Agencies',
				selectedMenuItem: undefined,
				menuItems: undefined,
			},
			[COBI_HIERARCHY.LINE_ITEM]: {
				text: 'Line Items',
				selectedMenuItem: undefined,
				menuItems: undefined,
			},
			[COBI_HIERARCHY.PROGRAM]: {
				text: 'Programs',
				selectedMenuItem: undefined,
				menuItems: undefined,
			},
		};

		this.menuOrder = [
			COBI_HIERARCHY.SUBCOMMITTEE,
			COBI_HIERARCHY.AGENCY,
			COBI_HIERARCHY.LINE_ITEM,
			COBI_HIERARCHY.PROGRAM
		];

		this.menuColumns = [
			'home',
			'committee',
			'agency',
			'lineItem'
		];

		this.state = {
			currentYear: _.cloneDeep(this.props.currentYear),
			currentMenuColumn: this.props.currentCobiId === 1 ? 'home' : this.props.menuMap[this.props.currentCobiId].orgType,
			isAjaxing: false,
			menuObj: _.cloneDeep(this.props.menuObj),
			menuMap: _.cloneDeep(this.props.menuMap),
			popupWindowOpen: false,
		};

		this.ajaxMenuById_CallbackId = ajaxStatus.registerChangedCallback((ajaxId, isAjaxing) => {
			this.setState({isAjaxing: isAjaxing});
		},WEBSERVICE_AJAX_ID.MENU_BY_ID);

		this.keyPressed = this.keyPressed.bind(this);
		this.clickOutside = this.clickOutside.bind(this);
	}

	componentDidMount() {
		document.activeElement.blur();
		document.addEventListener('keydown', this.keyPressed);
		document.addEventListener('click', this.clickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.keyPressed);
		document.removeEventListener('click', this.clickOutside);
		ajaxStatus.unregisterChangedCallback(this.ajaxMenuById_CallbackId);
	}

	keyPressed(e) {
		if (e.keyCode === 27) {
			this.props.menuClose();
		}
	}

	clickOutside() {
		console.log('UGH');
		this.props.menuClose();
	}

	queryMenuWS(cobiID, cobiYear) {
		webservice.public.navigation.menuById(cobiID,cobiYear)
			.then(value => {
				const menuMap = mapMenu(value);
				this.setState({
					currentMenuColumn: menuMap[cobiID].orgType,
					menuObj: value,
					menuMap: menuMap
				});
			})
			.catch(reason => console.log(reason));
	}

	queryAdminMenuWS(cobiID, cobiYear) {
		webservice.admin.navigation.menuById(cobiID,cobiYear)
			.then(value => {
				const menuMap = mapMenu(value);
				this.setState({
					currentMenuColumn: menuMap[cobiID].orgType,
					menuObj: value,
					menuMap: menuMap
				});
			})
			.catch(reason => console.log(reason));
	}

	generateMenuItems() {
		this.menuOrder.forEach(list => {
			this.menu[list].selectedMenuItem = undefined;
			this.menu[list].menuItems = undefined;
			const items = this.state.menuObj[list];
			if (items && items.length > 0) {
				this.menu[list].menuItems = items.map(i => {
					if (i.selected) {
						this.menu[list].selectedMenuItem = i;
					}
					return (
						<MainMenuItem
							key={i.cobiId}
							cobiId={i.cobiId}
							link={`${this.props.admin ? '/admin/editor' : ''}/${this.state.currentYear}/${i.cobiId}/${this.props.currentTab}${this.props.draft && !this.props.admin ? '/draft' : ''}`}
							loadMenu={(cobiId) => {window.scroll({top: 0, left: 0, behavior: "smooth"}); isAllowed() ? this.queryAdminMenuWS(cobiId, this.props.currentYear) : this.queryMenuWS(cobiId, this.props.currentYear);}}
							name={i.orgName}
							navigate={() => this.props.menuClose()}
							selected={i.selected}
							type={list}
							classNames={i.isActive ? '' : 'inactive'}
						/>
					);
				});
			}
		});
	}

	renderCobiArchiveLink(list) {
		let retVal;
		if (list === COBI_HIERARCHY.SUBCOMMITTEE) {
			retVal = (
				<a
					href="#"
					onClick={handleEvent(() => {
						this.setState({popupWindowOpen: true});
						document.removeEventListener('keydown', this.keyPressed);
						document.removeEventListener('click', this.clickOutside);
					}, true)}
					className="cobi-archive"
				>
					COBI Archive
				</a>
			);
		}
		return retVal;
	}

	renderCobiVersion(list) {
		let retVal;
		if (list === COBI_HIERARCHY.SUBCOMMITTEE) {
			retVal = (
				<div className="cobi-version">
					<Version/>
				</div>
			);
		}
		return retVal;
	}

	renderMenuItems() {
		let retVal = [];
		this.menuOrder.forEach(list => {
			retVal.push(
				<div key={list} className={`main-menu__items-column column-${list}`}>
					<div className="main-menu__column-title">{this.menu[list].text}</div>
					<ul id={`menu-list-${list}`}>
						{this.menu[list].menuItems}
					</ul>
					{this.renderCobiArchiveLink(list)}
					{this.renderCobiVersion(list)}
				</div>
			);
		});
		return retVal;
	}

	renderCurrentTopLinks() {
		let retVal = [];
		//Render the home link
		retVal.push(
			<div key="homeLink" className="main-menu__items-column main-menu__items-column--top-links">
				<Link to={`${this.props.admin ? '/admin/editor' : ''}/${this.state.currentYear}/1/${this.props.currentTab}${this.props.draft && !this.props.admin ? '/draft' : ''}`}
					  onClick={() => this.props.menuClose()}
					  className="summary menu-item-home">Statewide Overview {formatCobiYear(this.state.currentYear)}&nbsp;&raquo;
				</Link>
			</div>
		);
		//render other summary page links
		this.menuOrder.forEach((list,index) => {
			if (index < this.menuOrder.length-1) {
				retVal.push(
					<div key={list} className="main-menu__items-column main-menu__items-column--top-links">
						<Media
							query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}
							render={() => (<a onClick={() => {
								this.menu[list].selectedMenuItem.selected = false;
								this.setState({
									currentMenuColumn: this.menuColumns[index]
								});
							}} className="back">{iconCarretLeft()} Back To {this.menu[list].text}</a>)}
						/>
						{this.menu[list].selectedMenuItem &&
							<Link to={`${this.props.admin ? '/admin/editor' : ''}/${this.state.currentYear}/${this.menu[list].selectedMenuItem.cobiId}/${this.props.currentTab}${this.props.draft && !this.props.admin ? '/draft' : ''}`}
								  onClick={() => this.props.menuClose()}
								  className={`summary menu-item-${this.menu[list].selectedMenuItem.cobiId}`}
							>
								{`${this.menu[list].selectedMenuItem.orgName} summary`}&nbsp;&raquo;
							</Link>
						}
					</div>
				);
			}
		});
		return retVal;
	}

	changeCurrentYear(year) {
		dispatchUpdateData({path: 'app', field: 'currentYear', value: year});
		this.props.history.push(`${this.props.admin ? '/admin/editor' : ''}/${year}/${this.props.currentCobiId}/${this.props.currentTab}${this.props.draft && !this.props.admin ? '/draft' : ''}`);
		this.props.menuClose();
	}

	render () {
		this.generateMenuItems();
		return (
			<React.Fragment>
				{(this.state.popupWindowOpen) &&
				<PopupWindow onCloseButtonCallback={() => {
					this.setState({popupWindowOpen: false});
					document.addEventListener('keydown', this.keyPressed);
					document.addEventListener('click', this.clickOutside);
				}}>
					<h2>COBI Archive</h2>
					<div className="flex center flex-wrap">
						{this.props.fiscalYears.map(i => {
							if (i.listFY) {
								return (
									<Button label={`${formatCobiYear(i.sessionFY)}`} onClick={() => this.changeCurrentYear(i.sessionFY)} key={i.sessionFY} className="m-spacing-small" disabled={i.sessionFY === this.props.currentYear}/>
								);
							}
						})}
					</div>
				</PopupWindow>
				}
				<nav className="main-menu" onClick={e => e.nativeEvent.stopImmediatePropagation()}>
					<div className="main-menu__header flex align-center">
						<Button
							children={<div className="icon-tab">{iconX('hcenter vcenter')}</div>}
							childrenPosition={Button.CHILDREN_POSITION.BEFORE}
							className="main-menu__close-button button--icon-only button--solid button--tab-icon"
							onClick={this.props.menuClose}
						/>
						<span className="main-menu__header-title">Navigate</span>
						{this.state.isAjaxing && <AjaxSpinner size={20} className=""/>}
					</div>
					<div className={`main-menu__items-wrapper flex visible-column--${this.state.currentMenuColumn}`}>
						{this.renderCurrentTopLinks()}
					</div>
					<div className={`main-menu__items-wrapper flex visible-column--${this.state.currentMenuColumn}`}>
						{this.renderMenuItems()}
					</div>
				</nav>
			</React.Fragment>
		);
	}
}

MainMenu.propTypes = propTypes;

export default connect(mapStateToProps)(MainMenu);
